export const getSecondSelectorParameter = (_, secondParam) => secondParam;

export const getContextValue = (contextValue) => contextValue;

export const getProps = ({ props } = {}) => props || {};
export const getPropKey = (propKey) => (contextValue) => getProps(contextValue)[propKey];

export const getState = ({ state } = {}) => state || {};
export const getStateKey = (stateKey) => (contextValue) => getState(contextValue)[stateKey];
export const geIsOutSideClickCloseEnabled = getPropKey('isOutSideClickCloseEnabled');
export const geIsEnableCloseButtonForDesktop = getPropKey('isEnableCloseButtonForDesktop');
